import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualStaffPerformance from "./routes/IndividualStaffPerformance";
export default store => {
  return {
    path: "staff",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "staff" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualStaffPerformance(store)],
  };
};
